import styled from "@emotion/styled";

export const Centered = styled.div`
  comment: Centered;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const VerticallyCentered = styled.div`
  comment: Centered;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
